(function ($) {
	/**
	 * initializeBlock
	 *
	 * Adds custom JavaScript to the featured-video-block HTML.
	 *
	 * @date    04/05/2024
	 * @since   4.0.0
	 *
	 * @return  void
	 */
	const initializeBlock = function ($block) {};

	// Initialize each block on a page load (front end).
	$(document).ready(function () {
		$('.wp-block-acf-featured-video-block').each(function () {
			initializeBlock($(this));
		});
	});

	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction(
			'render_block_preview/type=featured-video-block',
			function ($block) {
				initializeBlock($($block));
			}
		);
	}
})(jQuery);
